import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-vax-thank-you',
  templateUrl: './vax-thank-you.component.html',
  styleUrls: ['./vax-thank-you.component.css']
})
export class VaxThankYouComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,) { }

  ngOnInit() {
  }
  startNewScreening(){
    this.router.navigateByUrl('/survey/vaxupload');
  }
}
